import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { get_account_moves } from "../services/services";
import ModalPago from "../home_alumnos/modalpago";
import logoSmall from "../assets/factura-final2.png";
import "./modal_facturas.css";

const ModalFacturas = ({ isOpen, onClose, userId }) => {
  const [facturasData, setFacturasData] = useState([]);
  const [ultimaFactura, setUltimaFactura] = useState(null);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [selectedFactura, setSelectedFactura] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [resumenPagos, setResumenPagos] = useState({
    totalPagado: 0,
    facturasPendientes: 0,
    ultimoPago: "-",
  });
  const [hasFetchedData, setHasFetchedData] = useState(false);

  const usuario = JSON.parse(localStorage.getItem("credenciales"));

  const formatNumber = (value) => {
    if (value === null || value === undefined || isNaN(value)) return "0,00";
    return new Intl.NumberFormat("es-ES", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(parseFloat(value));
  };

  useEffect(() => {
    const userData = localStorage.getItem("students");
    if (userData) {
      const parsedData = JSON.parse(userData);
      setIsAdmin(parsedData.is_admin || false);
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!isOpen || !userId || hasFetchedData) return;

      get_account_moves({ id: userId }, usuario, (flag, res) => {
        if (flag && Array.isArray(res)) {
          const todasLasFacturas = res.flat().map((factura) => ({
            ...factura,
            amount_total: parseFloat(factura.amount_total),
            amount_residual: parseFloat(factura.amount_residual),
            amount_tax: parseFloat(factura.amount_tax),
            line_ids: factura.line_ids?.map((line) => ({
              ...line,
              price_subtotal: parseFloat(line.price_subtotal),
              quantity: parseFloat(line.quantity),
            })),
          }));

          const facturasOrdenadas = todasLasFacturas.sort(
            (a, b) => new Date(b.invoice_date) - new Date(a.invoice_date)
          );

          setFacturasData(facturasOrdenadas);
          if (facturasOrdenadas.length > 0) {
            setUltimaFactura(facturasOrdenadas[0]);
          }

          const resumen = facturasOrdenadas.reduce(
            (acc, factura) => {
              const pagado = factura.amount_total - factura.amount_residual;
              acc.totalPagado += pagado;
              if (factura.amount_residual > 0) acc.facturasPendientes += 1;
              if (pagado > 0 && (!acc.ultimoPago || new Date(factura.invoice_date) > new Date(acc.ultimoPago))) {
                acc.ultimoPago = factura.invoice_date;
              }
              return acc;
            },
            { totalPagado: 0, facturasPendientes: 0, ultimoPago: null }
          );

          setResumenPagos(resumen);
          setHasFetchedData(true);
        }
      });
    };

    fetchData();
  }, [userId, isOpen, usuario, hasFetchedData]);

  const handlePagoClick = (e, factura) => {
    e.stopPropagation();
    if (factura.amount_residual > 0) {
      setSelectedFactura(factura);
      setIsPaymentModalOpen(true);
    }
  };

  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setHasFetchedData(false);
    onClose();
  };

  if (!isOpen) return null;

  const modalContent = (
    <div className="custom-modal-overlay" onClick={handleClose}>
      <div className="custom-modal-container" onClick={e => e.stopPropagation()}>
        <div className="modal fade show">
          <div className="modal-dialog modal-dialog-centered custom-modal-width">
            <div className="modal-content5 container">
              <div className="modal-header2">
                <h5 className="modal-title">Facturas del Usuario</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleClose}
                  aria-label="Close"
                ></button>
              </div>
              
              <div className="modal-body2">
                <div className="row">
                  <div className="col-md-6 factura-container">
                    <div className="datos-facturacion mb-4">
                      <div className="text-center position-relative">
                        <div className="imagen-container mb-3">
                          <img src={logoSmall} alt="Facturación" className="border p-2 factura" />
                          {ultimaFactura && ultimaFactura.line_ids?.length > 0 && (
                            <div className="factura-overlay" >
                              <div className="factura-details">
                                <div className="factura9" >
                                  <p className="p1" >{ultimaFactura.name || "N/A"}</p>
                                </div>
                                <div className="nombre9">
                                  <p className="p1">{ultimaFactura.partner_name || "N/A"}</p>
                                </div>
                                <div className="fecha_9">
                                  <p className="p1">{ultimaFactura.invoice_date || "N/A"}</p>
                                </div>
                                <div className="fecha_10">
                                  <p className="p1">{ultimaFactura.invoice_date_due || "N/A"}</p>
                                </div>
                                <div className="descripcion9">
                                  <p className="p1">{ultimaFactura.line_ids[0]?.product_name || "N/A"}</p>
                                </div>
                                <div className="cantidad9">
                                  <p className="p1">{ultimaFactura.line_ids[0]?.quantity || "N/A"}</p>
                                </div>
                                <div className="subtotal9">
                                  <p className="p1">${formatNumber(ultimaFactura.line_ids[0]?.price_subtotal)}</p>
                                </div>
                                <div className="iva9">
                                  <p className="p1">${formatNumber(ultimaFactura.amount_tax)}</p>
                                </div>
                                <div className="sub_total10">
                                  <p className="p1">${formatNumber(ultimaFactura.line_ids[0]?.price_subtotal)}</p>
                                </div>
                                <div className="total15">
                                  <p className="p1">${formatNumber(ultimaFactura.amount_total)}</p>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 historial-container">
                    <h3>Historial de pagos</h3>
                    <div className="datos-container">
                      <div className="row justify-content-center">
                        <div className="col-md-4 text-center">
                          <div className="dato-card p-2 rounded">
                            <h6 className="mb-1">Total Pagado</h6>
                            <p className="mb-0 fw-bold">${formatNumber(resumenPagos.totalPagado)}</p>
                          </div>
                        </div>
                        <div className="col-md-4 text-center">
                          <div className="dato-card1 p-2 rounded">
                            <h6 className="mb-1 alto">Facturas Pendientes</h6>
                            <p className="mb-0 fw-bold bold">{resumenPagos.facturasPendientes}</p>
                          </div>
                        </div>
                        <div className="col-md-4 text-center">
                          <div className="dato-card3 p-2 rounded">
                            <h6 className="mb-1 alto">Último Pago</h6>
                            <p className="mb-0 fw-bold bold">{resumenPagos.ultimoPago || "Sin pagos"}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="table-wrapper2">
                      <table className="users-table2">
                        <thead>
                          <tr>
                            <th>Fecha</th>
                            <th>Valor total</th>
                            <th>Valor adeudado</th>
                            <th>Estado</th>
                            {!isAdmin && <th>Acciones</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {facturasData.map((factura, index) => (
                            <tr key={index}>
                              <td>{factura.invoice_date}</td>
                              <td>${formatNumber(factura.amount_total)}</td>
                              <td>${formatNumber(factura.amount_residual)}</td>
                              <td>
                                <span className={`badge ${factura.amount_residual > 0 ? "estado-pendiente2" : "estado-pagado2"}`}>
                                  {factura.amount_residual > 0 ? "Pendiente" : "Pagado"}
                                </span>
                              </td>
                              {!isAdmin && (
                                <td>
                                  <button
                                    className="btn btn-primary btn-sm w-100"
                                    onClick={(e) => handlePagoClick(e, factura)}
                                    disabled={factura.amount_residual <= 0}
                                    style={{
                                      background: "#000000",
                                      border: "1px solid #000000",
                                      cursor: factura.amount_residual > 0 ? "pointer" : "default",
                                      zIndex: 10001,
                                    }}
                                  >
                                    {factura.amount_residual > 0 ? "Pagar" : "Pagado"}
                                  </button>
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleClose}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {ReactDOM.createPortal(modalContent, document.body)}
      <ModalPago
        isOpen={isPaymentModalOpen}
        onClose={() => setIsPaymentModalOpen(false)}
        userId={userId}
        valorPagar={selectedFactura?.amount_residual || 0}
        accountId={selectedFactura?.id || null}
        style={{ zIndex: 10001 }}
      />
    </>
  );
};

export { ModalFacturas };